import type { MyInvite } from "@/lib/myInvitesTypes";

export const initialMyInvites: MyInvite[] = [
  {
    id: "draft-aurora-supper",
    kind: "draft",
    status: "draft",
    title: "Aurora supper under the pier",
    recipientName: "Marta",
    theme: "romantic",
    animationMode: "typewriterReveal",
    media: {
      kind: "mixed",
      label: "3 photos + 1 voice note",
      detail: "Soft evening references, one short voice memo"
    },
    createdAt: "2026-06-18T15:20:00.000Z",
    expiresAt: "2026-06-24T23:59:00.000Z",
    premium: false
  },
  {
    id: "draft-midnight-toast",
    kind: "draft",
    status: "draft",
    title: "Midnight toast for Jules",
    recipientName: "Jules",
    theme: "festive",
    animationMode: "confettiYes",
    media: {
      kind: "image",
      label: "Cover photo + story clip",
      detail: "Album cover, confetti accents, and a short clip"
    },
    createdAt: "2026-06-20T11:10:00.000Z",
    expiresAt: "2026-06-27T18:00:00.000Z",
    premium: true
  },
  {
    id: "invite-rooftop-lina",
    kind: "published",
    status: "created",
    slug: "rooftop-lina",
    publicUrl: "https://invitation-app-2aa.pages.dev/i/rooftop-lina",
    title: "Rooftop welcome drinks",
    recipientName: "Lina",
    theme: "elegant",
    animationMode: "envelopeReveal",
    media: {
      kind: "image",
      label: "Invitation cover + RSVP art",
      detail: "Clean editorial image with soft gold accents"
    },
    createdAt: "2026-06-15T09:40:00.000Z",
    premium: true
  },
  {
    id: "invite-lanterns-ada",
    kind: "published",
    status: "sent",
    slug: "lanterns-ada",
    publicUrl: "https://invitation-app-2aa.pages.dev/i/lanterns-ada",
    title: "Paper lantern dinner",
    recipientName: "Ada",
    theme: "festive",
    animationMode: "confettiYes",
    media: {
      kind: "mixed",
      label: "Photo set + song",
      detail: "Seven photos, one audio note, and custom copy"
    },
    createdAt: "2026-06-13T17:05:00.000Z",
    premium: false
  },
  {
    id: "invite-cosmos-eli",
    kind: "published",
    status: "opened",
    slug: "cosmos-eli",
    publicUrl: "https://invitation-app-2aa.pages.dev/i/cosmos-eli",
    title: "Cosmic birthday teaser",
    recipientName: "Eli",
    theme: "cosmic",
    animationMode: "dramaticReveal",
    media: {
      kind: "video",
      label: "Motion teaser",
      detail: "Animated poster, 8-second clip, and soundtrack"
    },
    createdAt: "2026-06-11T12:15:00.000Z",
    premium: true
  },
  {
    id: "invite-museum-rosa",
    kind: "published",
    status: "responded",
    slug: "museum-rosa",
    publicUrl: "https://invitation-app-2aa.pages.dev/i/museum-rosa",
    title: "Museum date night",
    recipientName: "Rosa",
    theme: "minimal",
    animationMode: "swapButtons",
    media: {
      kind: "audio",
      label: "One voice note",
      detail: "Short audio intro and a clean RSVP page"
    },
    createdAt: "2026-06-09T08:30:00.000Z",
    premium: false,
    responseStatus: "yes",
    responseAt: "2026-06-10T19:24:00.000Z",
    responseLabel: "Rosa replied yes at 7:24 PM"
  },
  {
    id: "invite-apology-noah",
    kind: "published",
    status: "responded",
    slug: "apology-noah",
    publicUrl: "https://invitation-app-2aa.pages.dev/i/apology-noah",
    title: "An apology with room to breathe",
    recipientName: "Noah",
    theme: "elegant",
    animationMode: "lockedNo",
    media: {
      kind: "mixed",
      label: "Soft photo set + text",
      detail: "Muted imagery, minimal layout, and a response note"
    },
    createdAt: "2026-06-05T10:45:00.000Z",
    premium: true,
    responseStatus: "no",
    responseAt: "2026-06-07T09:15:00.000Z",
    responseLabel: "Noah replied no at 9:15 AM"
  }
];
